import { config } from "@/config";
import { useFlow } from "@frigade/react";
import * as Frigade from "@frigade/react";
import { OnboardingSteps } from "../OnboardingGuide";
import { useAppState } from "@/store/useApp";
import OnboardingFlow from "./OnboardingFlow";

const OnboardingFeedbackHintFlow = () => {
  const { flow } = useFlow(config.frigade.flows.gettingStarted);
  const currentStep = flow?.getCurrentStep();
  const grading = useAppState((state) => state.grading);

  if (!flow?.isCompleted && currentStep?.id as OnboardingSteps === "publish_feedback" && grading?.grade) {
    return (
      <OnboardingFlow>
        <Frigade.Tour
          flowId={config.frigade.flows.feedbackHint}
          defaultOpen={true}
          align={"center"}
          alignOffset={140}
        />
      </OnboardingFlow>
    );
  }
};

export default OnboardingFeedbackHintFlow;